<template>
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      <h5>การตั้งค่าวางเดิมพัน</h5>
    </div>
    <div class="ibox-content">
      <div class="panel with-nav-tabs">
        <div class="panel-heading">
          <ul class="nav nav-tabs" role="tablist">
            <li v-for="(game, key) in games" :key="'tab' + key" :class="{ 'active': panel === key }">
              <a @click="activePanel(key)" aria-controls="home" role="tab" data-toggle="tab" class="capitalize">{{ key | capitalize }}</a>
            </li>
          </ul>
        </div>
        <div class="panel-body">
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane" :class="{ 'active': panel === key }" v-for="(game, key) in games" :key="'panel' + key">
              <div class="table-responsive table-scrollable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th v-for="(config, type) in game.bet_limit" class="text-center capitalize" :key="type">{{ type }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="(config, index) in game.bet_limit" class="text-center" :key="index">
                        <span v-if="config.min">{{ config.min }} - {{ config.max }}</span>
                        <span v-else>{{ config }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'game-limitation',
    props: {
      userId: {
        required: true,
        type: [String, Number]
      },
      unapprove: {
        type: [Boolean],
        default: false
      },
      ignore: {
        type: [Array],
        default: () => {
          return [
            'baccarat_insurance',
            'baccarat_sixscore',
            // 'dragon_tiger'
          ]
        }
      }
    },
    data () {
      return {
        panel: 'baccarat',
        response: {}
      }
    },
    mounted () {
      const endpoint = !this.unapprove ? `/users/${this.userId}/config/games` : `/users/${this.userId}/config/games/unapprove`
      axios.get(endpoint)
        .then((response) => {
          this.response = response.data.games
        })
    },
    computed: {
      games () {
        const mapped = _.reduce(this.response, (obj, val, key) => {
          if (_.indexOf(this.ignore, key) === -1) {
            obj[key] = val
          }
          return obj
        }, {})

        return mapped
      }
    },
    methods: {
      activePanel (panel) {
        this.panel = panel
      }
    },
    filters: {
      capitalize (text) {
        const re = new RegExp('_', 'g');
        return text.replace(re, ' ')
      }
    }
  }
</script>
<style>
  .capitalize { text-transform: capitalize; }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/GameLimitation.vue